import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import LocalAuthorityListComponent from './local-authority-list-component';
import * as actions from '../../../actions';
import LocalAuthoritiesService from '../../../service/sfp/local-authorities-service';

class LocalAuthorityListContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {loading: true, localAuthorities: []};
		this._rejectFindLocalAuthorities = this._rejectFindLocalAuthorities.bind(this);
		this._resolveFindLocalAuthorities = this._resolveFindLocalAuthorities.bind(this);
	}

	componentDidMount() {
		LocalAuthoritiesService.findAllLocalAuthorities()
			.then(this._resolveFindLocalAuthorities, this._rejectFindLocalAuthorities);
	}

	render() {
		this.props.actions.setPageTitle('Collectivités');
		return (
			<LocalAuthorityListComponent
				loading={this.state.loading}
				localAuthorities={this.state.localAuthorities}/>
		)
	}

	_rejectFindLocalAuthorities(error) {
    this.props.actions.throwError(error);
    this.setState({error, loading: false});
	}

	_resolveFindLocalAuthorities(response) {
    this.setState({loading: false, localAuthorities: response});
	}
}

const mapDispatchToProps = dispatch => (
  {actions: bindActionCreators(actions, dispatch)}
);

export default connect(undefined, mapDispatchToProps)(LocalAuthorityListContainer);



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-list/index.js